export const listConnections = async (sendAndWaitWs, provider) => {
  const request = { provider };
  const response = await sendAndWaitWs(
    "/messaging/connection/list",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const getTelegramConnectionToken = async (sendAndWaitWs) => {
  const request = {};
  const response = await sendAndWaitWs(
    "/messaging/telegram/connect",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const disconnectTelegram = async (sendAndWaitWs, messengerId) => {
  const request = { messengerId };
  const response = await sendAndWaitWs(
    "/messaging/telegram/disconnect",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const checkTelegramTokenStatus = async (sendAndWaitWs, token) => {
  const request = { code: token };
  const response = await sendAndWaitWs(
    "/messaging/telegram/checkConnect",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const updateConnectionSettings = async (
  sendAndWaitWs,
  messengerId,
  settings
) => {
  const request = {
    messengerId,
    active: settings.active,
    notificationSetting: settings.notificationSetting,
    preferredName: settings.preferredName,
  };
  const response = await sendAndWaitWs(
    "/messaging/connection/update",
    JSON.stringify(request)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};
